import { LayoutProps } from './Layout.types'
import classes from './Layout.module.scss'

export function Layout({ children }: LayoutProps) {
  return <main className={classes.MainWrapper}>{children}</main>
}
